import { enqueueSnackbar } from "notistack";
import {GTBRecords, GTBRecordsHistory, GTBRequest, ServerAPIResponse } from "../helpers/interfaces";
import { callServerAPI, showBackDrop } from "../helpers/utils";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { isMapped } from "../helpers/constants";

const MySwal = withReactContent(Swal);


export const getAllGTBRecords = async (id: string) => {
    return await new Promise<GTBRecords[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading GTB Records"));
        callServerAPI<ServerAPIResponse<GTBRecords[]>>('GET',  `/api/v1/GTB?GTBFetchHistoryId=${id}&PageSize=5000&OrderBy=ASCENDING&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}


export const getGTBRecords =  async (mappingStatus:isMapped, recordsPerPage: Number,page:Number,yearFilter:Number) => {
    return await new Promise<any>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading GTB Records"));
        callServerAPI<ServerAPIResponse<any>>('GET', `/api/v1/GTB?Page=${page}&PageSize=${recordsPerPage}&api-version=1&IsMapped=${mappingStatus}&year=${yearFilter}`,  null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data)
            })
    })
}
export const getSAPGTBRecords = async (yearFilter:Number|undefined) => {
    return await new Promise<GTBRecords[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading GTB Records"));
        callServerAPI<ServerAPIResponse<GTBRecords[]>>('GET', `/api/v1/GTB/FetchSAPGTB?api-version=1&year=${yearFilter}`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}

export const fetchGTBRecordsHistory = async () => {
    return await new Promise<GTBRecordsHistory[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading GTB Records History"));
        callServerAPI<ServerAPIResponse<GTBRecordsHistory[]>>('GET', '/api/v1/GTB/GetGTBFetchHistory', null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}

export const UpdateGTBRecords = async ( gtbRequestDto:GTBRequest[]) => {
    return await new Promise<GTBRecords>(async (resolve, reject) => {
    MySwal.fire(showBackDrop(" Mapping GTB Records "));
       callServerAPI<ServerAPIResponse<GTBRecords>>('PATCH', '/api/v1/GTB?api-version=1', {"gtbRequests":gtbRequestDto}, true)
           .then(response => {
               MySwal.close()
               enqueueSnackbar(" GTB Records Updated", { variant: 'success' });
               resolve(response.data.data)
           })
        })
}

export const exportUnmappedGTB = async (pageSize:Number, year: Number) => {
    return await new Promise<string>(async (resolve, reject) => {
        MySwal.fire(showBackDrop(" Exporting Unmapped GTB "));
        callServerAPI<ServerAPIResponse<string>>('GET', `/api/v1/GTB/ExportUnmappedGTB?&api-version=1&pageSize=${pageSize}&year=${year}`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(" Unmapped GTB Exported", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}
export const exportAllUnmappedGTB = async (year: Number) => {
    return await new Promise<string>(async (resolve, reject) => {
        MySwal.fire(showBackDrop(" Exporting All Unmapped GTB "));
        callServerAPI<ServerAPIResponse<string>>('GET', `/api/v1/GTB/ExportUnmappedGTB?&api-version=1&year=${year}`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(" Unmapped GTB Exported", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}



export const exportAllMappedGTB = async (year: Number) => {
    return await new Promise<string>(async (resolve, reject) => {
        MySwal.fire(showBackDrop(" Exporting All Mapped GTB "));
        callServerAPI<ServerAPIResponse<string>>('GET', `/api/v1/GTB/ExportMappedGTB?api-version=1&year=${year}`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(" Mapped GTB Exported", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}
export const exportMappedGTB = async (pageSize:Number,year: Number) => {
    return await new Promise<string>(async (resolve, reject) => {
        MySwal.fire(showBackDrop(" Exporting Mapped GTB "));
        callServerAPI<ServerAPIResponse<string>>('GET', `/api/v1/GTB/ExportMappedGTB?api-version=1&pageSize=${pageSize}&year=${year}`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(" Mapped GTB Exported", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}


export const uploadGBTRecordsExcelFile = async (formData: FormData,year:number) => {
   
    return await new Promise<GTBRecords[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Uploading GTB Records"));
        callServerAPI<ServerAPIResponse<GTBRecords[]>>('POST', `/api/v1/GTB/ImportMappedGTB?api-version=1&year=${year}`, formData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("Upload Successful", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}